import React from 'react';
import PropTypes from 'prop-types';
import { Toolbar, SaveButton, DeleteButton } from 'react-admin';
import { withStyles } from '@material-ui/core';

import GuardedDeleteButton, {
  DeleteBlockersBanner,
  GUARDED_DELETE_RESOURCES,
  useDeleteBlockers,
} from '../button/GuardedDeleteButton';

const toolbarStyles = {
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
};

const FormToolbar = ({ isDeletable, redirect, ...props }) => {
  const { record, resource } = props;
  const guardedResource = GUARDED_DELETE_RESOURCES[resource];
  const pk = record && record.id;
  // Toujours appelé (règle des Hooks) : sans resource enrôlée, le hook ne
  // déclenche aucun appel réseau (voir son repli interne).
  const blockers = useDeleteBlockers(guardedResource, pk);

  return (
    <>
      {isDeletable && guardedResource && (
        <DeleteBlockersBanner blockers={blockers} />
      )}
      <Toolbar {...props}>
        <SaveButton />
        {isDeletable &&
          (guardedResource ? (
            blockers && (
              <GuardedDeleteButton
                resource={guardedResource}
                pk={pk}
                blockers={blockers}
                redirect={redirect}
              />
            )
          ) : (
            <DeleteButton redirect={redirect} />
          ))}
      </Toolbar>
    </>
  );
};

FormToolbar.propTypes = {
  isDeletable: PropTypes.bool,
  redirect: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.func,
  ]),
  // eslint-disable-next-line react/forbid-prop-types
  record: PropTypes.object,
  resource: PropTypes.string,
};

FormToolbar.defaultProps = {
  isDeletable: false,
  redirect: undefined,
  record: undefined,
  resource: undefined,
};

export default withStyles(toolbarStyles)(FormToolbar);
